/*
 * Copyright (c) 2023 Powerledger Pty Ltd. All Rights Reserved.
 */

import { TermsAndConditionsModalView } from "./terms-and-conditions-modal-view";
import { useTermsAndConditionsModal } from "./use-terms-and-conditions-modal";

export const TermsAndConditionsModal = () => {
  const { handleSubmit, handleCancel } = useTermsAndConditionsModal();

  return <TermsAndConditionsModalView handleSubmit={handleSubmit} handleCancel={handleCancel} />;
};
